import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PaintPour = function PaintPour(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.9997 11h-14m8-7-2-2m6 20h-12m20-6c0 1.1046-.8954 2-2 2s-2-.8954-2-2 2-3 2-3 2 1.8954 2 3m-13-13 6.8686 6.8686c.396.396.5941.5941.6682.8224a1 1 0 0 1 0 .618c-.0741.2283-.2722.4264-.6682.8224l-4.6059 4.6059c-.792.792-1.188 1.188-1.6447 1.3364a2 2 0 0 1-1.236 0c-.4567-.1484-.8527-.5444-1.6447-1.3364l-3.4746-3.4746c-.792-.792-1.188-1.188-1.3364-1.6447a2 2 0 0 1 0-1.236c.1484-.4567.5444-.8527 1.3364-1.6447z"
    })
  }));
};
export default PaintPour;